
import { createQuestionValueMap, mapToTupleArray,PageJson } from "../../../../common/summary-common/applicationSummary";
import { ConfirmationData, createFieldsGroups, updateMapWithFields } from "../../../../common/summary-common/confirmationData";

const defaultItems: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Dependiente", fontWeight: "bold" }],
    ["0a010b29-7593-4406-a2bb-e5ac91a7b035", {}],
    ["c25db4af-ac2f-4539-8490-735c10f388df", { fontWeight: "bold" }],
    ["0020fdeb-7776-4959-9ff2-198c2469eb27", { fontWeight: "bold" }],
    ["9e8e4349-5f9a-43e7-a048-856955040966", { fontWeight: "bold" }],
    ["773e8c82-3c69-4745-8520-43ac32b1b030", { fontWeight: "bold" }],
    ["6fe7ea08-6360-4d02-8fe5-3da568536456", { fontWeight: "bold" }],
    ["84f4b5e2-a240-4405-839b-a35924df2fa8", { fontWeight: "bold" }],
    ["3c7a2e47-5fc0-4e95-bcbf-0ee61d64a73d", { fontWeight: "bold" }],
    ["e42c12c2-443c-46c7-85b7-3ae3ea2e26e7", { fontWeight: "bold" }],
]);

const items = createFieldsGroups([], defaultItems);

export const defaultAdditionalInsured: Map<string, ConfirmationData> = new Map([
    ...items
]);

export const updateAdditionalInsured = (page: PageJson | undefined, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {
    if (page === undefined) {
        return new Map();
    }
    const section = page.sections.find(section => section.section_id === "9f75f289-6a25-4fff-94d5-99765c78ba6c");
    if (!section) {
        return cd;
    }
    const groups = section.groups.filter(group => group.group_id !== "d736ecdc-6ee5-44e1-a035-91c4fb7a8d7c" && group.group_id !== "c30e62e6-838d-48bd-968c-1760519e3535").sort((a, b) => a.order - b.order);
    const updatedItems = createFieldsGroups(groups, defaultItems);

    const answersMap = createQuestionValueMap(page);
    return updateMapWithFields(mapToTupleArray(answersMap), new Map([...cd, ...updatedItems]));
}